import { CdkPortal, DomPortalOutlet } from '@angular/cdk/portal';
import { AfterViewInit, ApplicationRef, Component, ComponentFactoryResolver, Injector, Input, ViewChild } from '@angular/core';
import { PrintSection } from 'src/app/models/web/print-section.model';
import { FormatUtils } from 'src/app/services/utilities/format-utils.service';

@Component({
    selector: 'app-print-view',
    templateUrl: './print-view.component.html',
    styleUrls: ['./print-view.component.scss'],
    standalone: false
})

export class PrintViewComponent implements AfterViewInit {
  @ViewChild(CdkPortal) public portal: CdkPortal;
  @Input() public title: string;
  @Input() public dateCreated: string;
  @Input() public printSections: PrintSection[];
  public objectKeys = Object.keys;
  public formatUtils = FormatUtils;
  private externalWindow: Window;
  private styleSheetElement: HTMLLinkElement;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) { }

  public ngAfterViewInit(): void {
    this.externalWindow = window.open('', '_blank');

    document.querySelectorAll('style').forEach(htmlElement => {
      this.externalWindow.document.head.appendChild(htmlElement.cloneNode(true));
    });

    this.styleSheetElement = this.getStyleSheetElement();
    this.externalWindow.document.head.appendChild(this.styleSheetElement);
    this.externalWindow.document.title = (this.title ?? 'Untitled') + ' - ' + this.dateCreated;

    // Create a PortalHost with the body of the new window document
    const host = new DomPortalOutlet(
      this.externalWindow.document.body,
      this.componentFactoryResolver,
      this.applicationRef,
      this.injector
    );

    host.attach(this.portal);
  }

  private getStyleSheetElement(): HTMLLinkElement {
    const styleSheetElement = document.createElement('link');
    document.querySelectorAll('link').forEach(htmlElement => {
      if (htmlElement.rel === 'stylesheet') {
        const absoluteUrl = new URL(htmlElement.href).href;
        styleSheetElement.rel = 'stylesheet';
        styleSheetElement.href = absoluteUrl;
      }
    });
    return styleSheetElement;
  }
}
